import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: 'BONO 1',
    title: 'Mi Primer Libro de Mitología Griega',
    desc: 'Una aventura ilustrada para niños y toda la familia, con actividades, juegos, personajes, héroes y criaturas que convierten el aprendizaje en diversión.'
  }, {
    num: 'BONO 2',
    title: 'Diccionario Ilustrado de Mitología Griega',
    desc: 'Una guía visual con cientos de personajes, dioses, criaturas, lugares, objetos y conceptos explicados de manera clara y entretenida.'
  }, {
    num: 'BONO 3',
    title: 'Atlas Ilustrado del Mundo Griego',
    desc: 'Viaja por ciudades legendarias, templos, montañas, islas y escenarios históricos mediante mapas, reconstrucciones e ilustraciones de gran calidad.'
  }, {
    num: 'BONO 4',
    title: 'El Gran Desafío de la Antigua Grecia',
    desc: 'Pon a prueba todo lo aprendido con cientos de preguntas, desafíos, acertijos y ejercicios para convertirte en un verdadero conocedor del mundo griego.'
  }];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-19">
            <Gift className="w-8 h-8 text-gold" data-id="element-20" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white" data-id="element-21">
            Además recibirás 4 Bonos Exclusivos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-22">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-23">
              {/* Ribbon effect */}
              <div className="absolute top-0 right-0 w-24 h-24 overflow-hidden" data-id="element-24">
                <div className="absolute top-4 -right-8 w-32 bg-gold text-dark text-xs font-bold py-1 text-center rotate-45 shadow-md" data-id="element-25">
                  GRATIS
                </div>
              </div>

              <div className="text-gold-light font-bold text-sm tracking-widest mb-2" data-id="element-26">
                {bono.num}
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-4 pr-8" data-id="element-27">
                {bono.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-28">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}